import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./shippingPartnerSlice";

export const selectDomain = (state) => state.shippingPartner || initialState;

export const makeSelectOne = createSelector(selectDomain, (state) => state.one);

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);
